import { onGetInstance } from "./helpers";

export default {
  install: (Vue) => {
    const instance = onGetInstance();

    Vue.prototype.$http = instance;
  },
};
